import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModelWithUser } from './base';
export let EUtteranceType;
(function (EUtteranceType) {
  EUtteranceType["BuiltIn"] = "built-in";
  EUtteranceType["Custom"] = "custom";
})(EUtteranceType || (EUtteranceType = {}));
export const fieldsUtterance = _extends({}, fieldsIBaseModelWithUser, {
  entities: {
    type: 'Unknown',
    array: true
  },
  intent: {
    type: 'Text'
  },
  key: {
    type: 'Text'
  },
  lang: {
    type: 'Text'
  },
  language: {
    type: 'Text'
  },
  ref: {
    type: 'Text'
  },
  text: {
    type: 'Text'
  },
  trained: {
    type: 'Boolean'
  },
  type: {
    type: 'Option',
    values: EUtteranceType
  }
});